// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Setup Page Styles */
.setup-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.setup-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%);
}

.setup-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1px);
}

.setup-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 600px;
  padding: 20px;
}

.setup-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 48px 40px;
  box-shadow: 
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04),
    0 0 0 1px rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.setup-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.logo-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.logo-icon svg {
  width: 32px;
  height: 32px;
  color: white;
}

.setup-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  letter-spacing: -0.025em;
}

.setup-subtitle {
  color: #64748b;
  font-size: 16px;
  margin: 8px 0 0 0;
  font-weight: 400;
}

.setup-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  width: 20px;
  height: 20px;
  color: #9ca3af;
  z-index: 1;
}

.input-container input {
  width: 100%;
  padding: 16px 16px 16px 48px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 16px;
  background: #ffffff;
  transition: all 0.2s ease;
  outline: none;
  box-sizing: border-box;
}

.input-container input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-container input:disabled {
  background: #f9fafb;
  color: #9ca3af;
  cursor: not-allowed;
}

.password-toggle {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  z-index: 1;
}

.password-toggle:hover:not(:disabled) {
  background: #f3f4f6;
}

.password-toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.password-toggle svg {
  width: 20px;
  height: 20px;
  color: #6b7280;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #dc2626;
  font-size: 15px;
  font-weight: 500;
}

.error-message svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.password-requirements {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
}

.password-requirements h4 {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.password-requirements ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.password-requirements li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #6b7280;
  position: relative;
  padding-left: 20px;
}

.password-requirements li::before {
  content: '○';
  position: absolute;
  left: 0;
  color: #d1d5db;
  font-weight: bold;
}

.password-requirements li.valid {
  color: #059669;
}

.password-requirements li.valid::before {
  content: '✓';
  color: #059669;
}

.setup-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
}

.setup-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.setup-button:active:not(:disabled) {
  transform: translateY(0);
}

.setup-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.setup-button svg {
  width: 20px;
  height: 20px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.setup-footer {
  margin-top: 32px;
}

.security-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 12px;
}

.security-info svg {
  width: 20px;
  height: 20px;
  color: #0369a1;
  flex-shrink: 0;
  margin-top: 2px;
}

.security-info p {
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
}

.security-info p:first-child {
  font-weight: 600;
  color: #0369a1;
  margin-bottom: 2px;
}

.security-info p:last-child {
  color: #0284c7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .setup-content {
    padding: 16px;
  }
  
  .setup-card {
    padding: 32px 24px;
    border-radius: 20px;
  }
  
  .setup-header h1 {
    font-size: 24px;
  }
  
  .setup-subtitle {
    font-size: 15px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .input-container input {
    padding: 14px 14px 14px 44px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
  
  .setup-button {
    padding: 14px 20px;
  }
}

@media (max-width: 480px) {
  .setup-card {
    padding: 24px 20px;
  }
  
  .logo-icon {
    width: 56px;
    height: 56px;
  }
  
  .logo-icon svg {
    width: 28px;
    height: 28px;
  }
  
  .setup-header h1 {
    font-size: 22px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .setup-card {
    background: rgba(17, 24, 39, 0.95);
    border: 1px solid rgba(75, 85, 99, 0.3);
  }
  
  .setup-header h1 {
    color: #f9fafb;
  }
  
  .setup-subtitle {
    color: #9ca3af;
  }
  
  .form-group label {
    color: #d1d5db;
  }
  
  .input-container input {
    background: #374151;
    border-color: #4b5563;
    color: #f9fafb;
  }
  
  .input-container input:focus {
    border-color: #667eea;
    background: #374151;
  }
  
  .input-container input:disabled {
    background: #1f2937;
    color: #6b7280;
  }
  
  .input-icon {
    color: #6b7280;
  }
  
  .password-toggle:hover:not(:disabled) {
    background: #4b5563;
  }
  
  .password-toggle svg {
    color: #9ca3af;
  }
  
  .password-requirements {
    background: #374151;
    border-color: #4b5563;
  }
  
  .password-requirements h4 {
    color: #d1d5db;
  }
  
  .password-requirements li {
    color: #9ca3af;
  }
  
  .password-requirements li::before {
    color: #6b7280;
  }
  
  .security-info {
    background: #1e3a8a;
    border-color: #3b82f6;
  }
  
  .security-info p:first-child {
    color: #93c5fd;
  }
  
  .security-info p:last-child {
    color: #bfdbfe;
  }
  
  .security-info svg {
    color: #60a5fa;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SetupPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;EAC7D,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;oFAGkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB;;;sCAGoC;EACpC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kCAAkC;IAClC,uCAAuC;EACzC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Setup Page Styles */\n.setup-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.setup-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%);\n}\n\n.setup-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(1px);\n}\n\n.setup-content {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  max-width: 600px;\n  padding: 20px;\n}\n\n.setup-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  padding: 48px 40px;\n  box-shadow: \n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04),\n    0 0 0 1px rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: slideUp 0.6s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.setup-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.logo-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.logo-icon {\n  width: 64px;\n  height: 64px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);\n}\n\n.logo-icon svg {\n  width: 32px;\n  height: 32px;\n  color: white;\n}\n\n.setup-header h1 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0;\n  letter-spacing: -0.025em;\n}\n\n.setup-subtitle {\n  color: #64748b;\n  font-size: 16px;\n  margin: 8px 0 0 0;\n  font-weight: 400;\n}\n\n.setup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 4px;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 16px;\n  width: 20px;\n  height: 20px;\n  color: #9ca3af;\n  z-index: 1;\n}\n\n.input-container input {\n  width: 100%;\n  padding: 16px 16px 16px 48px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 16px;\n  background: #ffffff;\n  transition: all 0.2s ease;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input-container input:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.input-container input:disabled {\n  background: #f9fafb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n  z-index: 1;\n}\n\n.password-toggle:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.password-toggle:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.password-toggle svg {\n  width: 20px;\n  height: 20px;\n  color: #6b7280;\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #dc2626;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.error-message svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.password-requirements {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.password-requirements h4 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 8px 0;\n}\n\n.password-requirements ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.password-requirements li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  color: #6b7280;\n  position: relative;\n  padding-left: 20px;\n}\n\n.password-requirements li::before {\n  content: '○';\n  position: absolute;\n  left: 0;\n  color: #d1d5db;\n  font-weight: bold;\n}\n\n.password-requirements li.valid {\n  color: #059669;\n}\n\n.password-requirements li.valid::before {\n  content: '✓';\n  color: #059669;\n}\n\n.setup-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.setup-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);\n}\n\n.setup-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.setup-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.setup-button svg {\n  width: 20px;\n  height: 20px;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.setup-footer {\n  margin-top: 32px;\n}\n\n.security-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 12px;\n}\n\n.security-info svg {\n  width: 20px;\n  height: 20px;\n  color: #0369a1;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.security-info p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n.security-info p:first-child {\n  font-weight: 600;\n  color: #0369a1;\n  margin-bottom: 2px;\n}\n\n.security-info p:last-child {\n  color: #0284c7;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .setup-content {\n    padding: 16px;\n  }\n  \n  .setup-card {\n    padding: 32px 24px;\n    border-radius: 20px;\n  }\n  \n  .setup-header h1 {\n    font-size: 24px;\n  }\n  \n  .setup-subtitle {\n    font-size: 15px;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .input-container input {\n    padding: 14px 14px 14px 44px;\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n  \n  .setup-button {\n    padding: 14px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .setup-card {\n    padding: 24px 20px;\n  }\n  \n  .logo-icon {\n    width: 56px;\n    height: 56px;\n  }\n  \n  .logo-icon svg {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .setup-header h1 {\n    font-size: 22px;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .setup-card {\n    background: rgba(17, 24, 39, 0.95);\n    border: 1px solid rgba(75, 85, 99, 0.3);\n  }\n  \n  .setup-header h1 {\n    color: #f9fafb;\n  }\n  \n  .setup-subtitle {\n    color: #9ca3af;\n  }\n  \n  .form-group label {\n    color: #d1d5db;\n  }\n  \n  .input-container input {\n    background: #374151;\n    border-color: #4b5563;\n    color: #f9fafb;\n  }\n  \n  .input-container input:focus {\n    border-color: #667eea;\n    background: #374151;\n  }\n  \n  .input-container input:disabled {\n    background: #1f2937;\n    color: #6b7280;\n  }\n  \n  .input-icon {\n    color: #6b7280;\n  }\n  \n  .password-toggle:hover:not(:disabled) {\n    background: #4b5563;\n  }\n  \n  .password-toggle svg {\n    color: #9ca3af;\n  }\n  \n  .password-requirements {\n    background: #374151;\n    border-color: #4b5563;\n  }\n  \n  .password-requirements h4 {\n    color: #d1d5db;\n  }\n  \n  .password-requirements li {\n    color: #9ca3af;\n  }\n  \n  .password-requirements li::before {\n    color: #6b7280;\n  }\n  \n  .security-info {\n    background: #1e3a8a;\n    border-color: #3b82f6;\n  }\n  \n  .security-info p:first-child {\n    color: #93c5fd;\n  }\n  \n  .security-info p:last-child {\n    color: #bfdbfe;\n  }\n  \n  .security-info svg {\n    color: #60a5fa;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
